export class XplanVersion {
    //public  facFinderId : string;
    public  userId : string;
    public  clientCode : string;
}

export class XplanVersionAddModel extends XplanVersion{    
       
}
